
import axios from 'axios'
const getDefaultState = () => {
    return {
        hasLoginCredential: false,
        LoginAccountType:'',
        FundList:'',
        IdType: '',
        OldId: '',      
        FullName : '',
        NRIC : '',
        Salutation: '',
        Nationality: '',
        CountryOfBirth: '',
        CityOfBirth: '',
        Gender: '',
        CustomerId: '',
        Email: '',
        MobileNoCode: '',
        MobileNo: '',
        MobileView:'',
        MaritalStatus: '',
        PermanentAddress: {
            Address_1: '',
            Address_2: '',
            Address_3: '',
            Postcode: '',
            TownCity: '',
            Country: '',
            State: '',
            StateForeign: ''
        },
        IsSamePermanentAddress: true,
        CorrespondenceAddress: {
            Address_1: '',
            Address_2: '',
            Address_3: '',
            Postcode: '',
            TownCity: '',
            Country: '',
            State: '',
            StateForeign: ''
        },
        NRIC_Front_FileName: '',
        NRIC_Back_FileName: '',
        OldId_FileName: '',
        InvestmentPurpose: [],
        InvestmentPurposeOther: '',
        SourceOfWealth: [],
        SourceOfWealthOther: '',
        IsDependents: false,
        NoOfDependents: '',
        MonthlyHouseholdIncome: '',
        Age: '',
        EPFNo: '',
        MaritalStatus: '',
        userID:'',
        password:'',
        isPwd: true,
        passwordConfirm:'',
        SubmitApplicantCredential: true,
        SamePassword:false,
        DOB:'',
        HolderStatus:'',
        Race:'',
        RaceOther:'',
        OpenDeclaration : false,
        OpenPopUp : false,
        step: 2,
        done4:false,
        TAC_code:'',
        TC_TransactionStatus :'', //success = 0000 any other code will be considered as failure
        EpfEmisTrxCode:'',
        FailReasonTitle : '',
        FailReasonBody : '',
        FailReason : '',
        ApplicationID:'',
        ApplicationFormID : '',
        InvestmentStep:'1',
        RedemptionStep : '1',
        SwitchingStep : '1',
        TC_Reason :'',
        InvestorName :'',
        AccountType :'',
        image_url :'',
        Creation_loginUserID :'',
        Creation_LoginPassword:'',
        Creation_uuid:'',
        loginUserID:'',
        LoginPassword:'',
        isPwd2:true
    }
}
const state = getDefaultState()

const getters = {
    Appdone: state => {}
}
const actions = {
    SetPermanentAddressByPostcode({ commit,state,rootState }, postcode) {
        for (var i = 0; i < rootState.Lookup.Postcode_LK.length; i++) {
            if (rootState.Lookup.Postcode_LK[i].Postcode === postcode) {
                state.PermanentAddress.TownCity = rootState.Lookup.Postcode_LK[i].City;
                state.PermanentAddress.Country = rootState.Lookup.Postcode_LK[i].Country;
                state.PermanentAddress.State = rootState.Lookup.Postcode_LK[i].State;
            }
        }
    },
    
    SetCorrespondenceAddressByPostcode({commit,state,rootState}, postcode) {  
          for (var i = 0; i < rootState.Lookup.Postcode_LK.length; i++) {
            if (rootState.Lookup.Postcode_LK[i].Postcode === postcode) {
                state.CorrespondenceAddress.TownCity = rootState.Lookup.Postcode_LK[i].City;
                state.CorrespondenceAddress.Country = rootState.Lookup.Postcode_LK[i].Country;
                state.CorrespondenceAddress.State = rootState.Lookup.Postcode_LK[i].State;
            }
        }
    },
}

// mutations
const mutations = {
    ResetState_AD(state) {
        Object.assign(state, getDefaultState())
    },
    SET_StatusByRace(state, Race) {
        if(Race === 'BU'){
            state.HolderStatus = 'BM'
        }else{
            state.HolderStatus = 'NB'
        }
    },
    SET_CorrespondenceAddresByPermanentAddress(state) {
        if (state.IsSamePermanentAddress === true) {
            state.CorrespondenceAddress.AddressLine1 = state.PermanentAddress.AddressLine1;
            state.CorrespondenceAddress.Address_2 = state.PermanentAddress.Address_2;
            state.CorrespondenceAddress.Address_3 = state.PermanentAddress.Address_3;
            state.CorrespondenceAddress.Postcode = state.PermanentAddress.Postcode;
            state.CorrespondenceAddress.TownCity = state.PermanentAddress.TownCity;
            state.CorrespondenceAddress.Country = state.PermanentAddress.Country;
            state.CorrespondenceAddress.State = state.PermanentAddress.State;
																						   
        }
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}